/* ═══════════════════════════════════════════════════════════════
   AYEZA FOOTER — torn edge, discount badge, scroll reveal (wordmark
   rise, title grow, letter scramble) and newsletter submit
   (Shopify customer + EmailJS). Uses window.AyzNav helpers when present.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var footer = document.querySelector('[data-ayz-footer]');
  if (!footer || footer.dataset.ayzReady) return;
  footer.dataset.ayzReady = '1';

  var nav = window.AyzNav || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (nav.injectMarkers) nav.injectMarkers(footer);

  /* ── Torn paper edge: seeded so every visit draws the same tear ── */
  (function tear() {
    var seed = parseInt(footer.dataset.tearSeed || '11', 10) || 11;
    function rand() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
    var steps = 96;
    var photo = [];
    var paper = [];
    for (var i = 0; i <= steps; i++) {
      var x = (i / steps * 100).toFixed(2) + '%';
      var y = 1.6 + rand() * 1.2 + (i % 11 === 0 ? rand() * 1.4 : 0);
      var p = Math.max(0, y - .5 - rand() * .9);
      photo.push(x + ' calc(' + y.toFixed(2) + ' * var(--ayz-u))');
      paper.push(x + ' calc(' + p.toFixed(2) + ' * var(--ayz-u))');
    }
    footer.style.setProperty('--ayz-tear', 'polygon(' + photo.join(', ') + ', 100% 100%, 0 100%)');
    footer.style.setProperty('--ayz-tear-paper', 'polygon(' + paper.join(', ') + ', 100% 100%, 0 100%)');
  })();

  /* ── Discount badge opens the discount popup ── */
  var discount = footer.querySelector('[data-ayz-discount-open]');
  if (discount) {
    var popup = document.getElementById('AyzPopup');
    if (!popup) {
      discount.parentElement.hidden = true;
    } else {
      discount.addEventListener('click', function () { popup.classList.add('is-active'); });
    }
  }

  /* ── Reveal ── */
  function reveal() {
    footer.classList.add('is-revealed');
    if (!nav.scramble) return;
    Array.prototype.forEach.call(footer.querySelectorAll('.ayz-footer__top [data-ayz-scramble]'), function (el, i) {
      nav.scramble(el, { delay: i * 0.04 });
    });
    Array.prototype.forEach.call(footer.querySelectorAll('.ayz-footer__bottom [data-ayz-scramble]'), function (el, i) {
      nav.scramble(el, { delay: 0.5 + i * 0.04 });
    });
  }

  if (!reduceMotion && 'IntersectionObserver' in window) {
    footer.classList.add('is-armed');
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      observer.disconnect();
      reveal();
    }, { rootMargin: '0px 0px -20% 0px' });
    observer.observe(footer);
  }

  /* ── Newsletter: save to Shopify customers + EmailJS welcome, no reload ── */
  var form = footer.querySelector('#FooterNewsletterForm');
  if (!form || form.dataset.initialized) return;
  form.dataset.initialized = 'true';
  var input = form.querySelector('input[type="email"]');
  var error = form.querySelector('[data-ayz-input-error]');
  var submitted = false;

  if (input) input.addEventListener('input', function () {
    if (submitted && error) error.hidden = input.checkValidity();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!input) return;
    submitted = true;
    if (!input.value || !input.checkValidity()) {
      if (error) error.hidden = false;
      input.focus();
      return;
    }
    if (error) error.hidden = true;
    var button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;

    try {
      if (typeof window.emailjs !== 'undefined') {
        window.emailjs.send('service_t0c464j', 'template_wvhda78', { to_email: input.value }, { publicKey: 'OI9CLHTsQXXQ5Gmvi' })
          .catch(function (err) { console.error(err); });
      }
    } catch (err) {
      console.error('EmailJS Error: ', err);
    }

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/x-www-form-urlencoded' }
    }).catch(function (err) { console.error('Fetch Error: ', err); });

    var success = document.createElement('p');
    success.className = 'ayz-newsletter__success';
    success.setAttribute('role', 'status');
    success.innerHTML = 'You’re on the list<small>Keep an eye on your inbox for early access.</small>';
    form.innerHTML = '';
    form.appendChild(success);
  });
})();
